import React from 'react';
import HeaderCell from 'components/common/ClinicManager/TableHeaderCell';
import StickyHeader from 'components/common/StickyHeader';
import Tooltip from 'components/common/Tooltip';
import './styles.scss';

interface IHeader {
  style: object;
  propName: string;
  text: string;
  sortable?: boolean;
}

const HEADERS: IHeader[] = [
  {
    style: { width: 120 },
    propName: 'lastName',
    text: 'Last Name',
    sortable: true,
  },
  {
    style: { width: 120 },
    propName: 'firstName',
    text: 'First Name',
    sortable: true,
  },
  {
    style: { width: 120 },
    propName: 'externalRef',
    text: 'External ID',
    sortable: false, // Sorting disabled for this column
  },
  {
    style: { width: 109 },
    propName: 'birthDate',
    text: 'DOB',
    sortable: true,
  },
  {
    style: { width: 109 },
    propName: 'programLabel',
    text: 'Product',
    sortable: true,
  },
  {
    style: { width: 199 },
    propName: 'healthCareProvider',
    text: 'Health Care Provider',
    sortable: true,
  },
  {
    style: { minWidth: 138 },
    propName: 'lastOpened',
    text: 'Last Opened',
    sortable: true,
  },
  {
    style: { width: 109 },
    propName: 'rxStartDate',
    text: 'Rx Start Date',
    sortable: true,
  },
  {
    style: { width: 138 },
    propName: 'rxDaysRemaining',
    text: 'Rx Days Remaining',
    sortable: true,
  },
];

export interface IProps {
  sortProp: Nullable<string>;
  sortOrder: Nullable<string>;
  sortBy: (prop: string) => void;
  hasPatientReadPermission: boolean;
}

export const Header = (props: IProps & { sticky?: string }) => {
  const [open, setOpen] = React.useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  return (
    <tr styleName="wrapper" data-testid="table-header">
      {HEADERS.map((header) => {
        // Only pass sort props if column is sortable
        const headerProps =
          header.sortable === false ? { ...props, sortBy: undefined } : props;

        return (
          <HeaderCell
            {...headerProps}
            theme="dark"
            key={header.propName}
            propName={header.propName}
            style={header.style}
          >
            <span>{header.text}</span>
          </HeaderCell>
        );
      })}
      {props.hasPatientReadPermission && (
        <HeaderCell
          {...props}
          theme="dark"
          key={'lastCell'}
          propName=""
          style={{ width: 108 }}
        >
          <span styleName="patient-snapshot-col">
            Patient Snapshot
            <Tooltip
              onClose={handleTooltipClose}
              title="A quick overview of your patient that you can download and print or upload to their chart."
              placement="top"
              open={open}
            >
              <div
                onMouseEnter={handleTooltipOpen}
                onMouseLeave={handleTooltipClose}
                onClick={handleTooltipOpen}
                styleName="icon"
              />
            </Tooltip>
          </span>
        </HeaderCell>
      )}
    </tr>
  );
};

const TableHeader = (props: IProps) => (
  <StickyHeader type="thead">
    <Header {...props} />
  </StickyHeader>
);

export default TableHeader;
